module.exports = __webpack_public_path__ + "static/img/CgoRDGNxtr6AfMYIABBPhse3434605.ea0c084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGNxtr6AfMYIABBPhse3434605.png
// module id = G0rD
// module chunks = 73